import BossModel from "@/models/BossModel";
import Surcharge from '@/models/Surcharge/Surcharge'
import Proposal from '@/models/Proposal/Proposal'
import Cancellation from "@/models/Proposal/Cancellation/Cancellation";

export default class ProposalSurcharge extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'proposal/surcharge';

    /**
     *
     * @type {string}
     */
    static entity = 'proposalSurcharges';

    static fields() {
		return {
			id: this.number(null).nullable(),
			proposal_id: this.number(null).nullable(),
			user_id: this.number(null).nullable(),
			surcharge_id: this.number(null).nullable(),
			proposal_cancellation_id: this.number(null).nullable(),
			debit_purchase_price: this.attr(null),
			purchase_price: this.attr(null),
			sale_price: this.attr(null),
			quantity: this.attr(null),
			name: this.attr(null),
			is_customer_visible: this.boolean(true),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            proposal: this.belongsTo(Proposal, 'proposal_id'),
            // user: User,
            surcharge: this.belongsTo(Surcharge, 'surcharge_id'),
            cancellation: this.belongsTo(Cancellation, 'proposal_cancellation_id'),
		}
	}

    /**
     *
     * @returns {boolean|*}
     */
    Surcharge(){
        return this.getRelated('surcharge');
    }

    /**
     *
     * @returns {boolean|*}
     */
    Proposal() {
        return this.getRelated('proposal');
    }
}
